import React from "react";
import { Modal, Button } from "react-bootstrap";
import parse from "react-html-parser";
// import './ConfirmationModel.css'

const CustomModel = ({
    show,
    onHide,
    title,
    content,
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header
                closeButton
                className="border-bottom py-3 add-agent-license"
            >
                <Modal.Title className="p-1 mb-0 add-agent-license-title roboto-regular" style={{ fontSize: '20px' }}>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={`py-3`}>
                <div style={{ "margin-top": "12px" }}>
                    <div className="search-criteria">
                        <div style={{fontFamily:'robotoregular', fontSize:'12.04px', color:'#000'}} className="search-criteria-lable">Search By:{" "}</div>
                        <div
                            style={{
                                color: "#787878",
                                fontFamily: "robotoregular",
                                fontSize: "12.04px"
                            }}
                        >
                            {content?.searchBy}
                        </div>
                    </div>

                    {/* Render search criteria key-values */}

                    {Array.isArray(content?.searchCriteriaListFormatted) &&
                        content.searchCriteriaListFormatted.length > 0 && (
                            <>
                                {content.searchCriteriaListFormatted.map((criteria, index) => (
                                    <div className="search-criteria" key={index}>
                                        <div style={{fontFamily:'robotoregular', fontSize:'12.04px', color:'#000'}} className="search-criteria-lable">{criteria.criteriaLabel}: </div>
                                        <div
                                            style={{
                                                color: "#787878",
                                                fontFamily: "robotoregular",
                                                fontSize: "12.04px"
                                            }}
                                        >
                                            {criteria.criteriaValue}
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}

                </div>
            </Modal.Body>
            {/* <Modal.Footer className="text-center py-2 justify-content-center border-top-0">
        {isForDelete ? (
          <div className="text-center d-flex justify-content-center mb-2">
            <button className="delete-btn" onClick={onYes}>
              {loading ? "Processing..." : "Delete Account"}
            </button>
          </div>
        ) : (
          <>
            <Button
              variant="primary"
              size="sm"
              onClick={onYes}
              disabled={loading}
              style={{fontSize: '14px', fontFamily: 'robotolight'}}
              className=" px-3"
            >
              {loading ? "Processing..." : yesButtonText}
            </Button>
            <Button
              variant="secondary"
              size="sm"
              onClick={onNo}
              disabled={loading}
              className="px-3"
              style={{fontSize: '14px', fontFamily: 'robotolight'}}
            >
              {noButtonText}
            </Button>
          </>
        )}
      </Modal.Footer> */}
        </Modal>
    );
};

export default CustomModel
    ;
